import { useCallback } from "react";
import { ToastManager } from "utilities/toast/toast-manager";

export default function useToastError(message: string) {
    return useCallback(() => ToastManager.error(message), [message]);
}
